import htmlSanitizer from "sanitize-html"

export const defaultConfig = {
  allowedTags: htmlSanitizer.defaults.allowedTags.concat([
    "img",
    "video",
    "audio",
    "track",
    "details",
    "summary"
  ]),
  allowedAttributes: {
    ...htmlSanitizer.defaults.allowedAttributes,
    iframe: [
      "src",
      "frameborder",
      "allow",
      "allowfullscreen",
      "scrolling",
      "sandbox"
    ],
    a: [...htmlSanitizer.defaults.allowedAttributes.a, "rel", "trigger-id"],
    video: ["src", "controls", "autoplay", "loop", "muted", "poster"],
    audio: ["src", "controls", "autoplay", "loop", "muted"],
    track: ["src", "label", "kind", "srclang"],
    blockquote: ["cite"],
    details: ["open"],
    time: ["datetime"],
    "*": [
      "style",
      "class",
      "title",
      "id",
      "alt",
      "aria-label",
      "align",
      "valign",
      "border",
      "cellpadding",
      "cellspacing",
      "colspan",
      "rowspan",
      "width",
      "height",
      "data-*",
      "bgcolor",
      "dir",
      "lang",
      "tabindex",
      "translate",
      "spellcheck"
    ]
  },
  textFilter: function (text) {
    // Sanitize-html will encode & into &amp;, so we decode it back to & only
    return text.replace(/&amp;/g, "&")
  }
}
/**
 * Sanitize a string to prevent XSS attacks
 * @param {string} html - The html string to sanitize
 * @param {config} config - The configuration object for the sanitizer
 * @returns {string} The sanitized string
 */
export const sanitizeHTML = (html, config) => {
  const options = { ...defaultConfig, ...config }
  return htmlSanitizer(html, options)
}
